import { useState } from "react";
import { askForItem, deleteItem } from "../api/Api";
import AddItemRow from "./AddItemRowComponent";
import Row from "./RowComponent";
import ErrorMessage from "./helpers/ErrorMessageComponent";
import MobileRow from "./MobileRowCompenent";

import styles from "../styles/mainPage.module.css";

function List(props) {

  // ---------------------------------------------------------------- state and hooks

  const [isAddingItem, setIsAddingItem] = useState(false);
  const [error, setError] = useState(null);

  // ---------------------------------------------------------------- logic

  async function addItemHandler(name, details) {
    setError(null);
    const itemObj = {
      name: name,
      details: details,
    };
    askForItem(props.selectedUser, itemObj)
      .then(() => {
        setIsAddingItem(false);
        props.fetchUsers();
      })
      .catch((error) => {
        console.log(error)
        setError('Something went wrong');
      });
  }

  function cancelAddItemHandler() {
    setError(null);
    setIsAddingItem(false);
  }

  async function deleteItemHandler(id) {
    setError(null);
    await deleteItem(id)
      .then(() => {
        props.fetchUsers();
      })
      .catch(() => {
        setError('Something went wrong');
      });
  }

  // ---------------------------------------------------------------- render

  const rows = window.screen.width > 500 ?
    // DESKTOP
    props.items.map((item) => (
      <Row
        key={item.id}
        item={item}
        claimItemHandler={() => props.claimItemHandler(item.id)}
        unclaimItemHandler={() => props.unclaimItemHandler(item.id)}
        deleteItemHandler={() => deleteItemHandler(item.id)}
      />
    ))
    :
    // MOBILE
    props.items.map((item) => (
      <MobileRow
        key={item.id}
        item={item}
        claimItemHandler={() => props.claimItemHandler(item.id)}
        unclaimItemHandler={() => props.unclaimItemHandler(item.id)}
        deleteItemHandler={() => deleteItemHandler(item.id)}
      />
    ));

  const addItemRow = isAddingItem ? (
    <AddItemRow
      cancelAddItemHandler={cancelAddItemHandler}
      addItemHandler={addItemHandler}
    />
  ) : (
    <tr>
      <td
        colSpan={'3'}
        style={{ textAlign: 'center', border: 'none' }}>
        <button onClick={() => setIsAddingItem(true)}>Add item</button>
      </td>
    </tr>
  );

  function genClaims() {
    if (props.claims === null) {
      return <></>;
    }

    // sort claims by asker
    const sortedClaims = Object.values(
      props.claims.reduce((prev, cur) => {
        const p = prev;
        const key = cur.askerName;
        p[key] = p[key] ?? [];
        p[key].push(cur);
        return p;
      }, {})
    );

    let claimTables;

    if (window.screen.width > 500) {
      claimTables = sortedClaims.map((claimGroup) => {
        const rows = claimGroup.map((claim) => (
          <Row
            key={claim.id}
            item={claim}
            isClaimRow={true}
            claimItemHandler={() => props.claimItemHandler(claim.id)}
            unclaimItemHandler={() => props.unclaimItemHandler(claim.id)}
            deleteItemHandler={() => deleteItemHandler(claim.id)}
          />)
        );

        return (
          <div key={claimGroup[0].askerName}>
            <h3>{claimGroup[0].askerName}</h3>
            <table style={{ tableLayout: 'fixed' }}>
              <thead>
                <tr>
                  <th style={{ width: '25%' }}>Item</th>
                  <th style={window.screen.width < 500 ? { width: '45%' } : { width: '50%' }}>Details</th>
                  <th style={window.screen.width < 500 ? { width: '30%' } : { width: '25%' }}>Claimed by</th>
                </tr>
              </thead>
              <tbody>
                {rows}
              </tbody>
            </table>
          </div>
        );
      });

    } else {
      claimTables = sortedClaims.map((claimGroup) => {
        const rows = claimGroup.map((claim) => (
          <MobileRow
            key={claim.id}
            item={claim}
            isClaimRow={true}
            claimItemHandler={() => props.claimItemHandler(claim.id)}
            unclaimItemHandler={() => props.unclaimItemHandler(claim.id)}
            deleteItemHandler={() => deleteItemHandler(claim.id)}
          />)
        );

        return (
          <div key={claimGroup[0].askerName}>
            <h3>{claimGroup[0].askerName}</h3>
            {rows}
          </div>
        );
      });
    }


    return (
      <div style={{ paddingTop: '50px' }}>
        <h2 className={styles.subheader}>My Claimed Items</h2>
        {claimTables}
      </div>);
  }

  if (window.screen.width > 500) {

    // ------------------------------------------------ DESKTOP
    return (
      <div>
        <table style={{ tableLayout: 'fixed' }}>
          <thead>
            <tr>
              <th style={{ width: '25%' }}>Item</th>
              <th style={window.screen.width < 500 ? { width: '45%' } : { width: '50%' }}>Details</th>
              <th style={window.screen.width < 500 ? { width: '30%' } : { width: '25%' }}>
                {props.selectedUser === sessionStorage.getItem('user') ? '' : 'Claimed By'}
              </th>
            </tr>
          </thead>
          <tbody>
            {rows}
            {addItemRow}
          </tbody>
        </table>

        {genClaims()}

        <ErrorMessage message={error} />
      </div>
    );

  } else {
    // ------------------------------------------------ MOBILE

    return (
      <div>
        <div className={styles.selectedList}>
          {rows}
        </div>
        
        <div className={isAddingItem ? null : styles.addRowContainer}>
          {addItemRow}
        </div>

        {genClaims()}

        <ErrorMessage message={error} />
      </div>
    );
  }
}

export default List;
